import { render } from "./FormularioRecital.vue?vue&type=template&id=3340621c&scoped=true&ts=true"
import script from "./FormularioRecital.vue?vue&type=script&lang=ts"
export * from "./FormularioRecital.vue?vue&type=script&lang=ts"

import "./FormularioRecital.vue?vue&type=style&index=0&id=3340621c&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3340621c"]])

export default __exports__